import type { ChatTranscript } from '@/pocs/chat/export/types'

export function toJson({
  title,
  exportedAt,
  contextFolders,
  exchanges,
}: ChatTranscript): string {
  return JSON.stringify(
    {
      title,
      exportedAt: exportedAt.toISOString(),
      contextFolders,
      exchanges,
    },
    null,
    2,
  )
}
